import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/CardComponent.css';

function CardComponent({ cardData }) {
  const { image, heading, description, link, downloadLink } = cardData;

  const imgStyle =
    heading === 'Our Services' || heading === 'View Our Certification'
      ? { objectFit: 'cover' }
      : {};

  const content = (
    <div className="card-content">
      <img src={image} alt={heading} className="card-image" style={imgStyle} />
      <h3 className="card-heading">{heading}</h3>
      <p className="card-text">{description}</p>
    </div>
  );

  if (downloadLink) {
    return (
      <a className="card" href={downloadLink} target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    );
  }

  return (
    <Link className="card" to={link || '/'}>
      {content}
    </Link>
  );
}

export default CardComponent;
